<template>
    <a :href="href" class="group bg-slate-50 text-slate-500 inline-flex hover:bg-slate-200 hover:text-slate-800 items-center justify-center rounded
        size-[30px] md:size-[50px]">
        <component :is="iconComponent"
            :class="['size-[14px] md:size-[20px]', defaultIconColorClass, hoverIconColorClass]" aria-hidden="true" />
    </a>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import { PencilIcon } from '@heroicons/vue/outline';

const props = defineProps({
    href: String,
    icon: Object,
    hoverIconColor: String,
    defaultIconColor: String
});

const iconComponent = computed(() => props.icon || PencilIcon);

const defaultIconColorClass = computed(() => {
    return props.defaultIconColor ? props.defaultIconColor : '';
});

const hoverIconColorClass = computed(() => {
    return props.hoverIconColor ? `group-hover:${props.hoverIconColor}` : '';
});
</script>